import i18n from "@/i18n"
import React from "react"
import styled from "styled-components"
import { Trans } from 'react-i18next'

const PreviewSection = styled.section`
    position: relative;
    display: flex;
    margin: 30px 0 0;
    min-height: 407px;
    width: 100%;
    gap: 10px;
    overflow: hidden;
`

const TutorialVideo = styled.video`
    border-radius: 12px 12px 4px 4px;
    background-color: #d4d4d4;
    display: flex;
    min-width: 240px;
    height: 407px;
    flex: 1;
    flex-basis: 0%;
    object-fit: cover;
`

const HeaderWrapper = styled.header`
    align-self: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 800;
`

const Heading = styled.h1`
    color: #83c308;
    font-size: 34px;
    line-height: 44px;
    letter-spacing: -0.68px;
`

const HeadingHighlight = styled.span`
    color: #222;
`

const SubHeading = styled.h2`
    color: #222;
    font-size: 22px;
    letter-spacing: -0.44px;
    margin: 10px 0 0;
`


const TutorialContainer = styled.main`
    background-color: #fff;
    display: flex;
    width: 900px;
    max-width: 100%;
    padding: 60px 0 0;
    flex-direction: column;
    overflow: hidden;
`

const BenefitCardWrapper = styled.span`
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);
    padding: 8px 12px;
    margin-top: 12px;
    text-align: left;
    
    &:first-child {
      margin-top: 0;
    }
`

const BenefitsContainer = styled.section`
    border-radius: 0 0 12px 12px;
    overflow: hidden;
`

const BenefitsWrapper = styled.div`
    background-color: #f1f1f1;
    display: flex;
    width: 900px;
    max-width: 100%;
    align-items: start;
    gap: 30px;
    overflow: hidden;
    justify-content: start;
    flex-wrap: wrap;
    padding: 60px 44px;
`

const BenefitsTitle = styled.h2`
    align-self: stretch;
    font-size: 34px;
    color: #83c308;
    font-weight: 800;
    letter-spacing: -0.68px;
    line-height: 44px;
    padding: 40px 0;
    text-align: left;
`

const ColoredText = styled.span`
    color: #222;
`

const BenefitsList = styled.div`
    display: flex;
    min-width: 240px;
    flex-direction: column;
    align-items: start;
    font-size: 18px;
    color: #515151;
    font-weight: 600;
    letter-spacing: -0.36px;
    justify-content: center;
`

function TutorialPreview({ lang }) {
    return (
        <PreviewSection>
            <TutorialVideo
                src={`${lang === 'ko' ? `https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/3_videomonster_plus.webm` : `https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/3_videomonster_plus_en.webm`}`}
                muted
                autoPlay
                loop
                playsInline
                webkit-playsinline
            />
        </PreviewSection>
    );
}

function TutorialHeader() {
    return (
        <HeaderWrapper>
            <Heading>
                {i18n.t("common.landing.guide.text_3")} <br />
                <HeadingHighlight>{i18n.t("common.landing.guide.text_4")}</HeadingHighlight>
            </Heading>
            <SubHeading>{i18n.t("common.landing.guide.text_5")}</SubHeading>
        </HeaderWrapper>
    );
}

function BenefitCard({ text }) {
    return (
        <BenefitCardWrapper>
            ✅ {text}
        </BenefitCardWrapper>
    )
}

function BenefitsSection() {
    const benefitsData = [
        { text: i18n.t("common.landing.guide.benefit_1") },
		{ text: i18n.t("common.landing.guide.benefit_2") },
		{ text: i18n.t("common.landing.guide.benefit_3") },
		{ text: i18n.t("common.landing.guide.benefit_4") },
		{ text: i18n.t("common.landing.guide.benefit_5") }
    ];
    return (
        <BenefitsContainer>
            <BenefitsWrapper>
                <BenefitsTitle>
					<Trans i18nKey="common.landing.guide.benefit.title_1"><ColoredText /></Trans>
                    <br />
                    <ColoredText>{i18n.t("common.landing.guide.benefit.title_2")}</ColoredText>
                </BenefitsTitle>
                <BenefitsList>
                    {benefitsData.map((benefit, index) => (
                        <BenefitCard key={index} text={benefit.text} />
                    ))}
                </BenefitsList>
            </BenefitsWrapper>
        </BenefitsContainer>
    )
}

export default function VideoGuideArea({ lang }) {
    return (
        <>
            <TutorialContainer>
                <TutorialHeader />
                <TutorialPreview lang={lang} />
                <BenefitsSection />
            </TutorialContainer>
        </>
    )
}